module.exports = __webpack_public_path__ + "media/application/images/svgs/cloud-off-1bee9d8acaee3c65c3e58b646b012241.svg";